module.exports = __webpack_public_path__ + "img/background-changer-before.74926850.jpg";